import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import Dashboard from './Dashboard';
import { actions as uiActions } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { IApplicationState } from 'ducks/reducers';
import { selectors as dashboardMaintenanceSelectors, actions as dashboardMaintenanceActions } from 'ducks/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';

const params = new URLSearchParams(location.search);

const mapStateToProps = (state: IApplicationState) => ({
    selectedDashboardId: dashboardMaintenanceSelectors.selected(state)?.DashboardId ?? params.get('DashboardId'),
    selectedDashboardType: dashboardMaintenanceSelectors.selected(state)?.DashboardType,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        changeSelectedTab: uiActions.changeSelectedTab,
        changeOperationMode: operationActions.changeOperationMode,
        changeSelectedRecord: dashboardMaintenanceActions.setSelected
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
